import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Oiltankportal (Clients, Realtors, Attorneys) Firebase configuration
const portalConfig = {
  apiKey: "AIzaSyDUpQKBAR75onJjWc_-i4BxvDnzmQ-W9Uc",
  authDomain: "oiltankportal.firebaseapp.com",
  projectId: "oiltankportal",
  storageBucket: "oiltankportal.appspot.com",
  messagingSenderId: "101379795965",
  appId: "1:101379795965:web:80eb8987cd47a5bf164794"
};

// Initialize Secondary Firebase App for portal
const portalApp = initializeApp(portalConfig, "portalApp");
const portalDb = getFirestore(portalApp);

// Get the auth instance for the portal app
export const portalAuth = getAuth(portalApp);

export { portalApp, portalDb }; 